/**
 * Product display identity. The user-facing product name and tagline live ONLY
 * here; UI copy that renders the brand must consume these constants.
 * (Technical identifiers — env var names, DB slugs, package names — are
 * deliberately separate and are NOT the product name.)
 */
export const PRODUCT_NAME = "Uday";

export const PRODUCT_TAGLINE = "AI agents for your workspace";
